(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["infinite-card-carousel"] && !Shopify.designMode) return;
  try {
    
  /**
   * <infinite-card-carousel>
   * Boucle infinie maison (scroll natif + clones + téléportation invisible),
   * volontairement indépendante de <slideshow-component> pour ne pas hériter
   * de son algorithme de rewind (voir commentaire en tête de section.liquid).
   */
  class InfiniteCardCarousel extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-carousel-viewport]');
      this.track = this.querySelector('[data-carousel-track]');
      this.prevButton = this.querySelector('[data-carousel-prev]');
      this.nextButton = this.querySelector('[data-carousel-next]');

      if (!this.viewport || !this.track) return;

      this.originalSlides = Array.from(this.track.children);
      if (this.originalSlides.length < 2) return;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.isCorrecting = false;
      this.groupWidth = 0;

      this._buildClones();
      this._bindEvents();

      // Attendre que le layout soit prêt avant de mesurer les largeurs.
      requestAnimationFrame(() => {
        this._measure();
        this._resetToStart();
      });

      this.resizeObserver = new ResizeObserver(() => this._handleResize());
      this.resizeObserver.observe(this.viewport);

      if (this.dataset.autoplay === 'true' && !this.reducedMotion) {
        this._startAutoplay();
      }
    }

    disconnectedCallback() {
      this._stopAutoplay();
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    _buildClones() {
      const makeClone = (node) => {
        const clone = node.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('inert', '');
        clone.querySelectorAll('a, button, [tabindex]').forEach((el) => el.setAttribute('tabindex', '-1'));
        return clone;
      };

      const leadingClones = this.originalSlides.map(makeClone);
      const trailingClones = this.originalSlides.map(makeClone);

      const fragmentStart = document.createDocumentFragment();
      leadingClones.forEach((clone) => fragmentStart.appendChild(clone));
      this.track.prepend(fragmentStart);

      const fragmentEnd = document.createDocumentFragment();
      trailingClones.forEach((clone) => fragmentEnd.appendChild(clone));
      this.track.append(fragmentEnd);
    }

    _measure() {
      // Les 3 groupes (clones-avant / originaux / clones-après) sont
      // strictement identiques : leur largeur totale est donc 1/3 du
      // scrollWidth du track.
      this.groupWidth = this.track.scrollWidth / 3;

      const gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap) || 0;
      const firstSlide = this.track.children[0];
      this.step = (firstSlide ? firstSlide.getBoundingClientRect().width : 0) + gap;
    }

    _resetToStart() {
      this.isCorrecting = true;
      // scrollTo({behavior:'instant'}) plutôt qu'une affectation de
      // .scrollLeft : .carousel__viewport a `scroll-behavior: smooth` pour
      // les clics sur les flèches, et une simple affectation de .scrollLeft
      // hériterait de ce smooth scroll (donc un glissement visible), ce qui
      // rendrait la téléportation de boucle repérable par l'œil.
      this.viewport.scrollTo({ left: this.groupWidth, behavior: 'instant' });
      requestAnimationFrame(() => {
        this.isCorrecting = false;
      });
    }

    _handleResize() {
      const previousGroupWidth = this.groupWidth;
      const offsetWithinGroup = this.viewport.scrollLeft - previousGroupWidth;
      this._measure();
      this.isCorrecting = true;
      this.viewport.scrollTo({ left: this.groupWidth + offsetWithinGroup, behavior: 'instant' });
      requestAnimationFrame(() => {
        this.isCorrecting = false;
      });
    }

    _bindEvents() {
      this.prevButton?.addEventListener('click', () => this._go(-1));
      this.nextButton?.addEventListener('click', () => this._go(1));

      this.viewport.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this._go(1);
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this._go(-1);
        }
      });

      let scrollEndTimer;
      this.viewport.addEventListener('scroll', () => {
        clearTimeout(scrollEndTimer);
        scrollEndTimer = setTimeout(() => this._maybeLoop(), 120);
      });

      this.addEventListener('pointerenter', () => this._stopAutoplay());
      this.addEventListener('pointerleave', () => {
        if (this.dataset.autoplay === 'true' && !this.reducedMotion) this._startAutoplay();
      });
      this.addEventListener('focusin', () => this._stopAutoplay());
      this.addEventListener('focusout', () => {
        if (this.dataset.autoplay === 'true' && !this.reducedMotion) this._startAutoplay();
      });
    }

    _go(direction) {
      if (!this.step) this._measure();
      this.viewport.scrollBy({
        left: direction * this.step,
        behavior: this.reducedMotion ? 'auto' : 'smooth',
      });
    }

    _maybeLoop() {
      if (this.isCorrecting || !this.groupWidth) return;
      const halfStep = (this.step || 0) / 2;
      const { scrollLeft } = this.viewport;

      if (scrollLeft < this.groupWidth - halfStep) {
        this.isCorrecting = true;
        this.viewport.scrollTo({ left: scrollLeft + this.groupWidth, behavior: 'instant' });
        this.isCorrecting = false;
      } else if (scrollLeft > this.groupWidth * 2 - halfStep) {
        this.isCorrecting = true;
        this.viewport.scrollTo({ left: scrollLeft - this.groupWidth, behavior: 'instant' });
        this.isCorrecting = false;
      }
    }

    _startAutoplay() {
      this._stopAutoplay();
      const speed = parseInt(this.dataset.autoplaySpeed, 10) || 4000;
      this.autoplayTimer = setInterval(() => this._go(1), speed);
    }

    _stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
  }

  if (!customElements.get('infinite-card-carousel')) {
    customElements.define('infinite-card-carousel', InfiniteCardCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
